import { render, staticRenderFns } from "./BuddycomCallTalkRecordList.vue?vue&type=template&id=3460078e&scoped=true"
import script from "./BuddycomCallTalkRecordList.vue?vue&type=script&lang=js"
export * from "./BuddycomCallTalkRecordList.vue?vue&type=script&lang=js"
import style0 from "./BuddycomCallTalkRecordList.vue?vue&type=style&index=0&id=3460078e&prod&lang=css"
import style1 from "./BuddycomCallTalkRecordList.vue?vue&type=style&index=1&id=3460078e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3460078e",
  null
  
)

export default component.exports